import { render } from "./RestorePromptConfirmationModal.vue?vue&type=template&id=6ed5b00c&scoped=true"
import script from "./RestorePromptConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RestorePromptConfirmationModal.vue?vue&type=script&lang=js"

import "./RestorePromptConfirmationModal.vue?vue&type=style&index=0&id=6ed5b00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed5b00c"]])

export default __exports__